<div class="agents-list-panel">
  <div class="list-header">
    <h2><mat-icon>smart_toy</mat-icon> My Teachers</h2>
    <button color="primary" mat-mini-fab matTooltip="New Agent" (click)="createAgentClicked.emit()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="agents-list">
    @for (agent of agents; track agent.id) {
      <div class="agent-item" [class.selected]="agent.id === selectedAgentId" (click)="select(agent)">
        <div class="agent-item-avatar" [ngClass]="'ring-' + agent.status">
          <mat-icon>{{ agent.avatarIcon }}</mat-icon>
          <span class="status-dot" [ngClass]="'dot-' + agent.status"></span>
        </div>
        <div class="agent-item-info">
          <span class="agent-item-name">{{ agent.name }}</span>
          <span class="agent-item-desc">{{ agent.description }}</span>
          <div class="agent-item-progress" *ngIf="agent.course">
            <mat-progress-bar mode="determinate" [value]="agent.course.progressPercent"></mat-progress-bar>
            <span class="progress-label">{{ agent.course.progressPercent }}%</span>
          </div>
        </div>
      </div>
    } @empty {
      <div class="empty-list">
        <mat-icon>psychology</mat-icon>
        <p>No teacher agents yet.<br />Create one to start a course!</p>
      </div>
    }
  </div>
</div>
